import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { signinRedirect, createUserManagerExtIdp } from '../services/userService';

export function useActions(scriptEnumsEvaluated): void {

    const location = useLocation();

    useEffect(() => {
        if (!scriptEnumsEvaluated)
            return
        const searchParams = new URLSearchParams(location.search);

        if (searchParams.has('action')) {
            const action = searchParams.get('action');

            if (action?.includes('login')) {
                const kcIdpHint = searchParams.get('kc_idp_hint');
                if (kcIdpHint) {
                    const um = createUserManagerExtIdp(kcIdpHint)
                    signinRedirect(um);
                }


            }
        }
    }, [location.search, scriptEnumsEvaluated]);
}
